module.exports = __webpack_public_path__ + "img/trash.9694707d.svg";